import { setupDesignStepListeners } from 'state/listeners/designStepListeners';

const setupAppListeners = () => {
  setupDesignStepListeners();
};

export default setupAppListeners;
